import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

const requestPath = '/api/v4/master/delete_all/trucks';

export const useDeleteAllTrucksMutation = () => ({
  post: useMutation(
    () => axios.post(requestPath),
  ),
});
